import { styled } from '@mui/material'

import { BoxWrapper } from '../wrapper'

export const TabBox = styled( BoxWrapper )(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  backgroundColor: theme.palette.grey[200],
  padding: '20px 50px'
}))